<template>
  <div class="wgtSettings">
    <div class="cardR">
      <div class="boxR">
        <div class="myZoomClass" :class="$store.state.TClrs" id="varianceheatsnap">
          <div class="content-panel1" v-show="IshourErr">
            <h2 class="chartTitle hide-on-presentation themeclr2">Variance Heatmap <small>(in hrs.)</small></h2>
            <apiErrorComponent @tryReload="tryReload" compTitle="Variance Heatmap" compId="varianceheatsnap">
            </apiErrorComponent>
          </div>
          <div class="content-panel1" v-show="!IshourErr" :class="{ 'contblinking': iskeyHM }">
            <div class="insideL  hide-on-presentation ">
              <div class="icon">
                <font-awesome-icon icon="fa-solid fa-bars" />
              </div>
              <div class="contents">
                <span v-show="!IshourErr">
                  <font-awesome-icon icon="fa-solid fa-diagram-successor" title="Switch to Alternate View"
                    v-if="loadDefault" v-on:click="drawHourlyInsights(0)" />
                  <font-awesome-icon icon="fa-solid fa-diagram-successor" title="Switch to Alternate View" v-else
                    v-on:click="drawHourlyInsights(1)" />
                  <font-awesome-icon icon="fa-solid fa-chalkboard-teacher" title="Add to Storyboard"
                    v-on:click="addToSlider()" />
                  <font-awesome-icon icon="fa-solid fa-file-download" title="Download Widget"
                    v-on:click="downloadDom()" />
                  <font-awesome-icon icon="fa-solid fa-file-export" title="Export Insights" v-on:click="downIns()" />
                </span>
              </div>
            </div>
            <div class="insideR hide-on-presentation">
              <div class="icon">
                <font-awesome-icon icon="fa-solid fa-info" />
              </div>
              <div class="contents">
                {{ $parent.widgetInfo.variance_heatmap }} You can click on individual boxes to get more
                insights.<br /><br />
                Actions you can take on this widget: <br />
                <ul>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-diagram-successor" /> to
                    swap between
                    priority and dropdown view
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-chalkboard-teacher" /> to
                    add to
                    storyboard
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-file-download" /> to
                    download the chart
                    with current insight
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-file-export" /> to download
                    all the
                    insights
                  </li>
                </ul>
              </div>
            </div>
            <div v-show="!isLoadhour">
              <widgetLoadingComp></widgetLoadingComp>
            </div>
            <div v-show="isLoadhour"></div>
            <h2 class="chartTitle hide-on-presentation themeclr2">Variance Heatmap <small>(in hrs.)</small></h2>
            <div class="varhMar" v-show="Ishourlyshow">
              <VueMultiselect class="mymultiselect  hide-on-presentation  variance-heat" openDirection="bottom" v-model="ReqFilterOp"
                :options="Reqpriors" :multiple="true" :allow-empty="false" deselect-label="can't Deselect"
                :close-on-select="false" placeholder="Search Domain" track-by="filter_drop" label="filter_drop"
                @close="renderTrend" selectLabel="" />
            </div>
            <div class="panel-body text-center varPanelHt" :class="{ 'BlurClass': !isLoadhour }">
              <div id="variance_dataviz" class="varPanelMg" v-show="Ishourlyshow"></div>
              <div v-if="Ishourdata" class="widgetError text-center">
                <widgetDataMsg></widgetDataMsg>
              </div>
            </div>
            <widgetsSlider :insideArr="hourlyInsight" :isInsErr="IshhInsErr" compTitle="Variance Heatmap"
              compId="varianceheatsnap" :isErr="IshourErr"></widgetsSlider>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
var hourly_swap_chart
var hourlywhole
var filt_val
var svg
var datasets
var gridSizeWid
var gridSize
import {
  useRoute
} from 'vue-router';
import * as d3 from 'd3'
import domtoimage from "dom-to-image-more"
import {
  saveAs
} from 'file-saver'
import widgetDataMsg from '../smallcomp/chartDataMsg.vue'
import widgetLoadingComp from '../smallcomp/widgetloader.vue'
import screenShotMix from "./../../mixin/screenShotMix";
import apiErrorComponent from '../smallcomp/apierror.vue'
import widgetsSlider from '../smallcomp/widgets-slider.vue';
export default {
  name: 'VarianceHeat',
  mixins: [screenShotMix],
  props: {
    getPins: Object,
    tabname: String,
  },
  data() {
    return {
      isLoadhour: false,
      IshourErr: false,
      Ishourlyshow: false,
      Ishourdata: false,
      istktshown: true,
      IshhInsErr: false,
      Reqpriors: [],
      hourlyInsight: [],
      filtsel: "",
      ReqFilterOp: [],
      loadDefault: false,
      iskeyHM: false,
    }
  },
  components: {
    widgetLoadingComp,
    widgetDataMsg,
    apiErrorComponent,
    widgetsSlider
  },
  methods: {
    tryReload() {
      this.getHourlyInsight(this.getwgtCond, this.filtsel, this.getPins.get_prior)
    },
    addToSlider() {
      let insArr = this.hourlyInsight;
      let name = "Variance Heatmap - " + this.getPins.viewName;
      let screenShort = {
        id: 'varianceheatsnap',
        name: 'varianceheatsnap.png'
      }
      this.addToSliderMix(screenShort, insArr, name)
    },
    downloadDom() {
      let imgname = "Variance_Heatmap.png"
      let widgetID = "varianceheatsnap"
      var geticondiv = document.querySelectorAll('#varianceheatsnap2 .insideL, #varianceheatsnap2 .insideR, .hide-on-presentation')
      geticondiv.forEach(box => {
        box.style.opacity = 0;
      });
      document.getElementById(widgetID).classList.remove("myZoomClass")
      domtoimage.toBlob(document.getElementById(widgetID))
        .then(function (blob) {
          saveAs(blob, imgname)
          geticondiv.forEach(box => {
            box.style.opacity = 1;
          });
          document.getElementById(widgetID).classList.add("myZoomClass")
        })
    },
    downIns() {
      let fileName = 'variance_heatmap_Insights.txt'
      let insArr = []
      insArr = this.hourlyInsight.join("\r\n");
      var fileToSave = new Blob([insArr], {
        type: 'application/json',
        name: fileName
      });
      saveAs(fileToSave, fileName)
    },
    drawHourlyInsights(val) {
      const self =this
      if (document.getElementById("variance_dataviz") != null && document.getElementById(
        "variance_dataviz") != undefined) {
        var charttext
        var days
        var loadDefault = this.loadDefault
        var emit = this.$emit
        var filt_val = this.filt_val
        if (this.getwgtCond == 2) {
          charttext = "MTTA"
        } else {
          charttext = "MTTR"
        }
        this.istktshown = true
        var margin = {
          top: 40,
          right: 50,
          bottom: 50,
          left: 130
        },
          width = document.getElementById("variance_dataviz").clientWidth - margin.left + 40,
          hrHeatMapheight = 370 - margin.top - margin.bottom,
          buckets = 9,
          colors = ['rgba(237,125,49, 0.1)', 'rgba(237,125,49, 0.15)', 'rgba(237,125,49, 0.2)',
            'rgba(237,125,49, 0.25)', 'rgba(237,125,49, 0.35)', 'rgba(237,125,49, 0.45)',
            'rgba(237,125,49, 0.6)', 'rgba(237,125,49, 0.8)', 'rgba(237,125,49, 1)'
          ],
          colorsG = ['rgba(11,104,2, 0.1)', 'rgba(11,104,2, 0.15)', 'rgba(11,104,2, 0.2)',
            'rgba(11,104,2, 0.25)', 'rgba(11,104,2, 0.35)', 'rgba(11,104,2, 0.45)',
            'rgba(11,104,2, 0.6)',
            'rgba(11,104,2, 0.8)', 'rgba(11,104,2, 1)'
          ],
          colorsR = ['rgba(191,68,76, 0.1)', 'rgba(191,68,76, 0.15)', 'rgba(191,68,76, 0.2)',
            'rgba(191,68,76, 0.25)',
            'rgba(191,68,76, 0.35)', 'rgba(191,68,76, 0.45)', 'rgba(191,68,76, 0.6)',
            'rgba(191,68,76, 0.8)',
            'rgba(191,68,76, 1)'
          ];
        var times = [charttext, "30min", "1hr", "2hr", "4hr", "8hr", "12hr", "24hr", "1.5d", "2d", "3d",
          "4d",
          "5d", "7d", "9d", "10d", "20d", "30d", "40d", "50d", "60d", "70d", "80d", "90d", ">90d"
        ];
        var myValue = [0, 30, 60, 120, 240, 192, 720, 1440, 2160, 2880, 4320, 5760, 7200, 10080, 12960,
          14400,
          28800, 43200, 57600, 72000, 86400, 100800, 115200, 129600
        ];
        var gridSize = Math.floor(width / 24);
        var legendElementWidth = gridSize * 2;
        if (val == 0) {
          days = hourlywhole.yaxis
          datasets = hourlywhole.chart;
          this.loadDefault = false
          gridSize = Math.floor(width / 25)
          legendElementWidth = gridSize * 2
          gridSize = gridSize > 38 ? 38 : gridSize
        } else {
          days = hourly_swap_chart.yaxis
          datasets = hourly_swap_chart.chart
          this.loadDefault = true
          gridSize = Math.floor(width / 50)
          legendElementWidth = gridSize * 4
          gridSize = gridSize > 26 ? 26 : gridSize
        }
        gridSizeWid = Math.floor((width - 50) / 25)
        d3.select("#variance_dataviz").select("svg").remove()
        svg = d3.select("#variance_dataviz").append("svg")
          .attr("width", width + margin.left + margin.right)
          .attr("height", hrHeatMapheight + margin.top + margin.bottom)
          .append("g")
          .attr("transform", "translate(" + margin.left + "," + margin.top + ")")
        var dayLabels = svg.selectAll(".dayLabel")
          .data(days)
          .enter().append("text")
          .text(function (d) {
            return d;
          })
          .style("font-size", "8px")
          .attr("x", 0)
          .attr("y", function (d, i) {
            return i * gridSize
          })
          .style("text-anchor", "end")
          .attr("transform", "translate(-6," + gridSize / 1.5 + ")")
          .attr("class", function (d, i) {
            return "dayLabel mono axis axis-workweek";
          });
        var timeLabels = svg.selectAll(".timeLabel")
          .data(times)
          .enter().append("text")
          .text(function (d) {
            return d;
          })
          .attr("x", function (d, i) {
            return (i) * gridSizeWid
          })
          .attr("y", 0)
          .style("text-anchor", "middle")
          .attr("transform", "translate(" + gridSizeWid / 2 + ", -6)")
          .attr("class", function (d, i) {
            return ((i >= 7 && i <= 16) ? "timeLabel mono axis axis-worktime" :
              "timeLabel mono axis");
          });
        heatmapChart(datasets)
      }
      function txtToTime(getpier) {
        var pier = Math.round(getpier)
        var hours = Math.floor(pier / 60)
        var minutes = pier % 60
        var timeret = ""
        if (hours > 0) {
          if (hours < 24) {
            timeret += hours + "h "
          } else {
            var days = Math.floor(hours / 24)
            hours = hours - (days * 24)
            timeret += days + "d " + hours + "h "
          }
        }
        if (minutes > 0) {
          timeret += minutes + "m ";
        }
        if (timeret == "") {
          timeret = "< 1min"
        }
        return timeret
      }
      function heatmapChart(data) {
        var maxValueArr = d3.max(data, function (d) {
          if (d.hour != 0) {
            return d.value;
          }
        });
        if (maxValueArr <= 6) {
          buckets = 3;
          colors = ['rgba(237,125,49, 0.35)', 'rgba(237,125,49, 0.6)', 'rgba(237,125,49, 1)'];
          colorsG = ['rgba(11,104,2, 0.35)', 'rgba(11,104,2, 0.6)', 'rgba(11,104,2, 1)'];
          colorsR = ['rgba(191,68,76, 0.35)', 'rgba(191,68,76, 0.6)', 'rgba(191,68,76, 1)'];
        } else if (maxValueArr <= 20) {
          buckets = 5;
          colors = ['rgba(237,125,49, 0.25)', 'rgba(237,125,49, 0.45)', 'rgba(237,125,49, 0.6)',
            'rgba(237,125,49, 0.8)', 'rgba(237,125,49, 1)'
          ];
          colorsG = ['rgba(11,104,2, 0.25)', 'rgba(11,104,2, 0.45)', 'rgba(11,104,2, 0.6)',
            'rgba(11,104,2, 0.8)', 'rgba(11,104,2, 1)'
          ];
          colorsR = ['rgba(191,68,76, 0.25)', 'rgba(191,68,76, 0.45)', 'rgba(191,68,76, 0.6)',
            'rgba(191,68,76, 0.8)', 'rgba(191,68,76, 1)'
          ];
        }
        var colorScale = d3.scaleQuantile()
          .domain([0, buckets - 1, d3.max(data, function (d) {
            if (d.hour != 0) {
              return d.value;
            }
          })])
          .range(colors);
        var colorScaleG = d3.scaleQuantile()
          .domain([0, buckets - 1, d3.max(data, function (d) {
            if (d.hour != 0) {
              return d.value;
            }
          })])
          .range(colorsG);
        var colorScaleR = d3.scaleQuantile()
          .domain([0, buckets - 1, d3.max(data, function (d) {
            if (d.hour != 0) {
              return d.value;
            }
          })])
          .range(colorsR);
        var cards = svg.selectAll(".hour")
          .data(data, function (d) {
            return d.day + ':' + d.hour
          });
        cards.append("title");
        cards.enter().append("rect")
          .attr("x", function (d) {
            return ((d.hour) * gridSizeWid) + 2
          })
          .attr("y", function (d) {
            return ((d.day - 1) * gridSize) + 2
          })
          .style("fill", function (d) {
            if (d.value == 0) {
              return "transparent"
            } else if (d.hour == 0) {
              return "transparent"
            } else if (data[(d.day - 1) * 25].value > myValue[d.hour]) {
              return colorScaleG(d.value)
            } else {
              return colorScaleR(d.value)
            }
          })
          .attr("rx", 2)
          .attr("ry", 2)
          .attr("class", function (d) {
            if (d.hour == 0) {
              return "";
            } else if (data[(d.day - 1) * 25].value > myValue[d.hour]) {
              if (d.value == 0) {
                return "hour borderedGreen1"
              }
              return "hour borderedGreen"
            } else {
              if (d.value == 0) {
                return "hour borderedRed1"
              }
              return "hour borderedRed"
            }
          })
          .on('click', function (d, i) { //do stuff
            if (d.currentTarget.__data__.value != 0) {
              let selectedWord
              if (self.loadDefault == true) {
                selectedWord = hourly_swap_chart.yaxis[d.currentTarget.__data__.day - 1] + "~" +
                  times[d.currentTarget.__data__.hour]
                let clickitem = {
                  "currpass": selectedWord,
                  "filterop": "analyseBy~bucket",
                }
                emit("getKDrill", clickitem)
              } else {
                selectedWord = hourlywhole.yaxis[d.currentTarget.__data__.day - 1] + "~" +
                  times[d.currentTarget.__data__.hour]
                let clickitem = {
                  "currpass": selectedWord,
                  "filterop": "priority~bucket",
                  "filt_val": filt_val
                }
                emit("getKDrill", clickitem)
              }
            }
          })
          .attr("width", gridSizeWid - 4)
          .attr("height", gridSize - 4)
          .append("svg:title");
        cards.select("title").text(function (d) {
          return d.value
        });
        var valuesText = svg.selectAll(".valuesText")
          .data(data)
          .enter()
          .append("text")
          .attr("class", function (d) {
            var tempCValArr = colorScale(d.value).split(",");
            var tempOVal = parseFloat(tempCValArr[3].slice(0, -1).trim());
            if (data[(d.day - 1) * 25].value > myValue[d.hour]) {
              return tempOVal < 0.5 ? "lghtVTxtG txtcls" : "drkVTxt txtcls";
            } else {
              return tempOVal < 0.5 ? "lghtVTxtR txtcls" : "drkVTxt txtcls";
            }
          })
          .attr("x", function (d, i) {
            return (i % 25) * gridSizeWid;
          })
          .attr("y", function (d) {
            return ((d.day - 1) * gridSize) + gridSize;
          })
          .on('click', function (d, i) { //do stuff
            if (d.currentTarget.__data__.value != 0) {
              let selectedWord
              if (self.loadDefault == true) {
                selectedWord = hourly_swap_chart.yaxis[d.currentTarget.__data__.day - 1] + "~" +
                  times[d.currentTarget.__data__.hour]
                let clickitem = {
                  "currpass": selectedWord,
                  "filterop": "analyseBy~bucket",
                }
                emit("getKDrill", clickitem)
              } else {
                selectedWord = hourlywhole.yaxis[d.currentTarget.__data__.day - 1] + "~" +
                  times[d.currentTarget.__data__.hour]
                let clickitem = {
                  "currpass": selectedWord,
                  "filterop": "priority~bucket",
                  "filt_val": filt_val
                }
                emit("getKDrill", clickitem)
              }
            }
          })
          .style("text-anchor", "middle")
          .attr("transform", "translate(" + gridSizeWid / 2 + ", -" + (gridSize / 2 - 3) + ")")
          .attr("rx", 2)
          .attr("ry", 2)
          .style("font-size", "10px")
          .text(function (d) {
            if (d.value == 0 || d.hour == 0) {
              return "";
            }
            return Math.abs(d.value) > 999 ? Math.sign(d.value) * ((Math.abs(d.value) / 1000)
              .toFixed(1)) + 'k' : Math.sign(d.value) * Math.abs(d.value);
          });
        cards.exit().remove()
      }

    },
    renderTrend(filtsel) {
      filt_val = []
      for (var i = 0; i < filtsel.length; i++) {
        if (filtsel[i] != undefined)
          filt_val.push(filtsel[i].filter_drop)
      }
      this.getHourlyInsight(1, filt_val, this.getPins.get_prior)
    },
    getHourlyInsight(cond, filtsel, get_prior) {
      this.isLoadhour = false,
        this.IshourErr = false,
        this.Ishourlyshow = false,
        this.Ishourdata = false,
        this.istktshown = true,
        this.IshhInsErr = false
      this.axios.post(this.uriApiUrl + 'DataAnalysis/get_varheat_map?asg_id=' + this.asgId + "&Cond=" +
        cond, {
        "filt_val": filtsel,
        "get_prior": get_prior,
        "selid": this.getPins.selid,
        "edited": this.getPins.edited
      },{
      headers: {
            'Content-Type': 'application/json'
          }})
        .then((response) => {
          if (response.status == 200) {
            if (response.data != "Error" && response.data != "Nodata" && response.data.chart !=
              "Error") {
              hourlywhole = response.data.chart
              hourly_swap_chart = response.data.swap_chart
              this.Reqpriors = hourlywhole.Filter_dropdown
              this.ReqFilterOp = []
              for (let i = 0; i < this.Reqpriors.length; i++) {
                if (this.Reqpriors[i].ticked == true) {
                  this.ReqFilterOp.push({
                    "filter_drop": this.Reqpriors[i].filter_drop
                  })
                }
              }
              this.hourlyInsight = hourlywhole.insights
              for (var i = 0; i < this.hourlyInsight.length; i++) {
                this.hourlyInsight[i] = this.hourlyInsight[i].replace(/\|/g, '').replace(/~/g,
                  '')
              }
              this.Ishourlyshow = true
              if (this.hourlyInsight.length == 0) {
                this.IshhInsErr = true
              }
              setTimeout(() => {
                this.drawHourlyInsights(0)
              }, 5)
            } else if (response.data == "Nodata") {
              this.Ishourdata = true
            } else {
              this.IshourErr = true
              this.$notify({
                type: "error",
                text: 'Sorry! Something went wrong in Variance Heatmap. Try after sometime!'
              })
            }
            this.isLoadhour = true
          }
        }).catch((response) => {
          this.IshourErr = true
          this.isLoadhour = true
          if (this.enabledDebug == 1) {
            this.$notify({
              type: "error",
              text: 'Sorry! Something went wrong in Variance Heatmap. Try after sometime!'
            })
          }
        })
    }
  },
  mounted() {
    const route = useRoute()
    this.asgId = route.params.asgid
    this.getHourlyInsight(this.getwgtCond, this.filtsel, this.getPins.get_prior)
  },
  computed: {
    getwgtCond() {
      return this.$store.state.widgetCond
    }
  },
  watch: {
    getPins() {
      this.getHourlyInsight(this.getwgtCond, this.filtsel, this.getPins.get_prior)
    },
    getpass() {
      this.getHourlyInsight(this.getwgtCond, this.filtsel, this.getPins.get_prior)
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.varPanelHt {
  height: 390px;
}

.varPanelMg {
  cursor: pointer;
}

.varhMar {
  margin: 10px 0 10px 0;
}
</style>